import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { API_ENDPOINT } from '../../index';
import {
    Row,
    Col,
    Button,
    Popconfirm,
    Modal,
    Tag,
    Card
} from 'antd'

const colorTckEvent = {
    "Picked Up": "#7cb305",
    "Arrived Hub": "#7cb305",
    
    "Delivered": "#3f6600",
    "Proof of Delivery": "#3f6600",

    "In Transit to Destination": "blue",
    "Out for Delivery": "blue",
    "In Transit to Destination":"blue",

    "Pickup Arranged": "geekblue",
    

    "Delivery Attempted - Inaccurate/Incomplete Address": "red",
    "Delivery Attempted - Adverse Weather": "red",
    "Delivery Attempted - No One Available/Home": "red",
    "Delivery Attempted - Unavoidable Delay": "red",
    "Delivery Attempted - Consignee Refused": "red",
    "Delivery Attempted - Unable to Locate Consignee": "red",
    "Delivery Attempted - Consignee Moved": "red",
    "Delivery Attempted - Unable To Access Premises": "red",
    "Not Delivered - Vehicle Break Down": "red",

    "held in TCK facility": "gold"


}

class TckCheckerEventTimeline extends React.Component {

    constructor(props) {
        super(props);
    }

    

    render(){

        

        return(
            <Row style={{marginTop:"15px"}}>
                <Col type="flex" justify="space-between" align="middle" >
                    <Tag color={colorTckEvent[this.props.event.EventName] ? colorTckEvent[this.props.event.EventName] : null} >
                        <Row>
                            <b>{ this.props.event.EventName }</b>
                        </Row>
                        <Row>
                            { this.props.event.EventDateTime }
                        </Row>
                    </Tag>
                    {
                        this.props.event.PodURL &&
                        <Row>
                            <Button href={this.props.event.PodURL } size="large" />
                        </Row>
                    }
                </Col>
            </Row>
        )
    }

    shouldComponentUpdate(nextProps){

        if(this.props.event.length != nextProps.event.length){
            return true
        }

        return false
    }


    renderCardStyle = (location) => {
        let style = {
            backgroundColor: `#ffff`
        }
        if(this.props.selectedLocations.includes(location._id)){
            style.backgroundColor =  "#91d5ff"
        }
        if(location.dateCompleted){
            style.backgroundColor =  "#95de64"
        }
        return style
    }

}
export default TckCheckerEventTimeline;


// WEBPACK FOOTER //
// ./src/components/delivery-page/TckCheckerEventTimeline.js